import React, { useState } from 'react';
import { Button } from '@cp/ds/src/components/button';
import { FormField } from '@cp/ds/src/components/form';
import { ModalView } from '@cp/ds/src/components/modalView';
import { SelectItemModel, SelectValueConstraint } from '@cp/ds/src/components/select/model';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { useIsMobile } from '@cp/ds/src/hooks';
import Sort from 'src/assets/shapes/sort.svg';

type SortButtonProps = {
  fieldName: string;
  sortingItems: SelectItemModel<SelectValueConstraint>[];
};

export const SortButton: React.FC<SortButtonProps> = ({ fieldName, sortingItems }) => {
  const isMobile = useIsMobile();
  const [bannerOpen, setOpen] = useState(false);

  const sortingItemsList = sortingItems.map((item, index) => ({
    ...item,
    label: index === 0 ? <Typography variant="body bold">По умолчанию</Typography> : <Typography variant="body bold">{item.label}</Typography>,
  }));

  return (
    <>
      <Button onClick={() => setOpen(true)} variant="text">
        <Stack alignItems="center" direction="row" sx={{ width: '100%', gap: 0.5 }}>
          <Sort />
          <Typography variant="caption">Сортировка</Typography>
        </Stack>
      </Button>
      <ModalView
        config={{ mobile: 'drawerBottom', desktop: 'dialog' }}
        isOpen={bannerOpen}
        onClose={() => setOpen(false)}
        scrollableContainerSx={{ pt: '40px', backgroundColor: 'white' }}
      >
        <Stack gap={2} sx={{ py: 1, borderRadius: '16px', alignItems: 'stretch', textAlign: 'start' }}>
          {isMobile && (
            <Typography sx={{ textAlign: 'center' }} variant="h5">
              Сортировка
            </Typography>
          )}
          <FormField
            callback={() => setOpen(false)}
            itemSx={{ width: '100%', textAlign: 'start' }}
            items={sortingItemsList}
            multiple={false}
            name={fieldName}
            sorters
            type="checkboxGroup"
          />
        </Stack>
      </ModalView>
    </>
  );
};
